var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sidebarOpen),expression:"sidebarOpen"}],staticClass:"sidebar",class:{ right: _vm.right }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }